import routes from 'modules/requirements/common/routing/routes'

export const requirementsRoutes = {
  root: routes.root,
  group: `${routes.root}/group`,
  adaptiveLearning: `${routes.root}/adaptive-learning`,
}

export default requirementsRoutes
